module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f4F2Y"))).then(() => parcelRequire('ikE14'));